import { createUseStyles } from 'react-jss';
import {
  clearButton,
  disabled,
  highlightedMenuItem,
  inputWrapper,
  invisibleMenu,
  menu,
  menuItem,
  placeholder,
  selectedMenuItem,
  value,
  valueContainer,
  DropdownStylesData,
} from '@tcl-boron-foundations/downshift-dropdown';
import { Classes } from 'jss';

export const useSingleSelectDropdownStyles: (
  data: DropdownStylesData & {
    theme?: Jss.Theme;
  },
) => Classes<
  | 'clearButton'
  | 'disabled'
  | 'highlightedMenuItem'
  | 'inputWrapper'
  | 'invisibleMenu'
  | 'menu'
  | 'menuItem'
  | 'placeholder'
  | 'selectedMenuItem'
  | 'value'
  | 'valueContainer'
> = createUseStyles({
  clearButton,
  disabled,
  highlightedMenuItem,
  inputWrapper,
  invisibleMenu,
  menu,
  menuItem,
  placeholder,
  selectedMenuItem: { ...selectedMenuItem, fontWeight: 500, justifyContent: 'space-between' },
  value,
  valueContainer,
});
